import { useFonts } from "expo-font";


export const useCustomFonts = () => {
  return useFonts({
    Roboto: require("../../assets/fonts/Roboto-Thin.ttf"),
    RobotoMedium: require("../../assets/fonts/Roboto-Medium.ttf"),
    RobotoRegular: require("../../assets/fonts/Roboto-Regular.ttf"),
    RobotoBold: require("../../assets/fonts/Roboto-Bold.ttf"),
    OpenSansRegular: require("../../assets/fonts/OpenSans-Regular.ttf"),
    OpenSansSemiBold: require("../../assets/fonts/OpenSans-Semibold.ttf"),
    MontserratLight: require("../../assets/fonts/Montserrat-Light.otf"),
  })
};
